module.exports = __webpack_public_path__ + "static/media/times-internet-logo.469c4a1f.png";